module.exports = __webpack_public_path__ + "static/media/list.9bc873d5.svg";